import { resourcesAction } from './actions';

import {
    RESOURCES_REQUEST_START,
    RESOURCES_REQUEST_FAIL,
    RESOURCES_REQUEST_SUCCESS
} from './types';

type ResourcesState = {
    loadingState: string,
    allResources: any
};

const INITIAL_STATE: ResourcesState = {
    loadingState: 'UNINITIALISED',
    allResources: null
};

export const reducer = (
    state: ResourcesState = INITIAL_STATE,
    action: resourcesAction
): ResourcesState => {
    switch (action.type) {

        case RESOURCES_REQUEST_START:
            return {
                ...state,
                loadingState: 'LOADING',
                allResources: null
            };

        case RESOURCES_REQUEST_SUCCESS:
            return {
                ...state,
                loadingState: 'LOADED',
                allResources: action.payload
            };

        case RESOURCES_REQUEST_FAIL:
            return {
                ...state,
                loadingState: 'ERROR',
                allResources: null
            };

        default:
            return state;
    }
};